<template>
  <div class="book-container">
    <!-- 头部导航 -->
    <van-nav-bar 
      :title="navTitle" 
      left-arrow 
      @click-left="onClickLeft" 
      fixed 
      placeholder 
      class="dark-nav"
    />

    <!-- 分类区域 -->
    <div class="category-container" v-if="!['purchased', 'favorite'].includes(activeTab)">
      <div class="sub-category-grid">
        <div 
          class="sub-cat-tag" 
          :class="{ active: !activeCateId  }"
          @click="activeCateId=0"
        >
          全部
        </div>
        <div 
          class="sub-cat-tag" 
          v-for="(item, index) in categoryList" 
          :key="item.id || index"
          v-if="item?.id!=''"
          :class="{ active: activeCateId === item.id }"
          @click="onCategoryChange(item)"
        >
          {{ item.category_name }}
        </div>
      </div>
    </div>

    <!-- 列表区域 (一排两个，暗黑奢华卡片) -->
    <div class="list-container">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh" class="dark-refresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多内容了"
          @load="onLoad"
        >
          <div class="book-grid">
            <div class="book-card"  v-for="item in bookList" :key="item.id" @click="goToDetail(item)">
                <!-- 封面区域 -->
              <div class="cover-wrapper">
                <img class="cover-img" :id="item.number ? item.number + '_img' : 'img_' + item.id" :src="item.is_new === 1 ? item.cover : ''" style="object-fit: cover;" />
                
                <!-- 类型角标 -->
                <div class="type-badge">{{ item.type }}</div>
                <!-- 状态角标 -->
                <div class="status-badge" v-if="item.statusText">{{ item.statusText }}</div>
              </div>
              
              <!-- 底部信息区域 -->
              <div class="book-info">
                <!-- 标题 -->
                <div class="book-title">
                  {{ item.title }}
                </div>
                
                <!-- 小说分类 -->
                <div class="book-time">
                  分类: {{ item.categoryText }}
                </div>
                
                <!-- 数据统计 -->
                <div class="book-stats">
                  <span class="stat-item">
                    <van-icon name="eye-o" style="    margin-top: 3px;"/> <span class="stat-item">{{ formatCount(item.viewCount) }}</span>
                  </span>
                  <span class="stat-item">
                    <van-icon name="star-o" class="star-icon" /> {{ formatCount(item.favoriteCount) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>

    <!-- 底部炫酷导航栏 -->
    <div class="cyber-tabbar" :style="{ background: `linear-gradient(to right, ${color || '#6197B1'}, ${backcolor || '#B4CCF6'})` }">
      <div class="tab-item" :class="{ active: activeTab === 'home' }" @click="onTabClick('home')">
        <van-icon name="video-o" class="tab-icon" />
        <span class="tab-text">热门视频</span>
      </div>
      <div class="tab-item" :class="{ active: activeTab === 'book' }" @click="onTabClick('book')">
        <van-icon name="fire-o" class="tab-icon" />
        <span class="tab-text">热门小说</span>
      </div>
      <div class="tab-item" :class="{ active: activeTab === 'purchased' }" @click="onTabClick('purchased')">
        <van-icon name="bag-o" class="tab-icon" />
        <span class="tab-text">已购买</span>
      </div>
      <div class="tab-item" :class="{ active: activeTab === 'favorite' }" @click="onTabClick('favorite')">
        <van-icon name="like-o" class="tab-icon" />
        <span class="tab-text">已收藏</span>
      </div>
    </div>
  </div>

</template>

<script>
import { bksApi, bksListApi, booksBuyApi, booksCollectionListApi } from "@/api/api";

export default {
  name: 'BookList',
  data() {
    return {
      categoryList: [], // 一级分类数据
      activeCateId: 0,
      
      bookList: [],
      loading: false,
      finished: false,
      refreshing: false,
      
      params: {
        cate_id: 0,
        key: '',
        ldk: '',
        payed: 0,
        uid: '',
        page: 1,
        limit: 10,
        templete_id: 1,
        webmanage: 0,
      },
      
      activeTab: 'book', // 默认激活小说列表状态
      color: '',
      backcolor: '',
    };
  },
  computed: {
    navTitle() {
      if (this.activeTab === 'purchased') return '已购资源';
      if (this.activeTab === 'favorite') return '我的收藏';
      return '资源列表';
    }
  },
  watch: {
    '$route.query.tab': {
      handler(newTab) {
        if (newTab) {
          this.activeTab = newTab;
          this.onRefresh();
        }
      },
      immediate: true
    }
  },
  created() {
    this.color = window.localStorage.getItem('color');
    this.backcolor = window.localStorage.getItem('backcolor');
    this.params.ldk = window.localStorage.getItem('ldk') || '';
    this.params.uid = window.localStorage.getItem('visitorId') || '';
    
    this.getCategoryList();
  },
  methods: {
    // 获取分类列表
    getCategoryList() {
      bksApi({ ldk: this.params.ldk }).then(res => {
        this.categoryList = [{ id: 0, name: '全部' }];
        if (res) {
          let list = JSON.parse(this.$decryptData(res));
          list.forEach(item => {
            this.categoryList.push(item);
          });
        }
      });
    },
    // 底部导航点击
    onTabClick(tab) {
      if (tab === 'home') {
        this.$router.push('/');
      } else {
        this.activeTab = tab;
        this.onRefresh();
      }
    },
    // 返回上一页
    onClickLeft() {
      this.$router.go(-1);
    },
    // 切换分类
    onCategoryChange(item) {
      this.activeCateId = item.id;
      this.params.cate_id = item.id;
      this.onRefresh();
    },
    // 下拉刷新
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.params.page = 1;
      this.bookList = [];
      this.onLoad();
    },
    // 上拉加载更多
    onLoad() {
      if (this.refreshing) {
        this.bookList = [];
        this.refreshing = false;
      }
      
      this.params.sp = window.localStorage.getItem('sp');
      this.params.ua = window.localStorage.getItem('parent');
      
      let apiCall;
      if (this.activeTab === 'purchased') {
        apiCall = booksBuyApi(this.params);
      } else if (this.activeTab === 'favorite') {
        apiCall = booksCollectionListApi(this.params);
      } else {
        apiCall = bksListApi(this.params);
      }
      
      apiCall.then(res => {
        this.loading = false;
        if (res) {
          let temp = JSON.parse(this.$decryptData(res));
          console.log(temp);
          if (temp.data && temp.data.length > 0) {
            let newData = temp.data.map(item => {
              // 寻找当前分类名称
              let typeName = '小说';
              let cate = this.categoryList.find(c => c.id === this.params.cate_id);
              if (cate && cate.name !== '全部') {
                typeName = cate.name;
              } else if (item.novel_type_text) {
                typeName = item.novel_type_text;
              } else if (item.cate_name) {
                typeName = item.cate_name;
              }
              
              return {
                id: item.id,
                title: item.novel_title || item.title,
                cover: item.cover_url || item.thumb_image || '',
                type: typeName,
                publishTime: item.update_time_at || item.day || item.created_at || '最近更新',
                categoryText: item.category_text || typeName,
                statusText: item.serialize_status_text || '',
                viewCount: item.look_count || item.views || Math.floor(Math.random() * 800000),
                favoriteCount: item.collect_count || item.collects || Math.floor(Math.random() * 60000),
                is_new: Number(item.is_new) || 0,
                number: item.number,
                originalItem: item
              };
            });
            
            this.bookList = [...this.bookList, ...newData];
            
            // 自动加载旧版本图片的兼容逻辑（参考index.vue）
            this.$nextTick(() => {
              newData.forEach(item => {
                if (item.is_new === 0 && item.number) {
                  this.resetImgUrl(item.number + '_img', item.cover);
                }
              });
            });

            if (this.params.page < temp.last_page) {
              this.params.page++;
            } else {
              this.finished = true;
            }
          } else {
            this.finished = true;
          }
        } else {
          this.finished = true;
        }
      }).catch(err => {
        console.error(err);
        this.loading = false;
        this.finished = true;
      });
    },
    // 处理图片错误兼容逻辑
    preView(blob, element) {
      let reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onload = function (e) {
          const imgElement = document.getElementById(element);
          if (imgElement) {
              imgElement.src = e.target.result;
          }
      };
    },
    jsReadFiles(blob, element) {
      var reader = new FileReader();
      reader.readAsArrayBuffer(blob);
      reader.onload = function () {
          var result = new Blob([reader.result.slice(3)], { type: 'image/jpeg' });
          this.preView(result, element);
      }.bind(this);
    },
    resetImgUrl(imageobj, url) {
      if (!url) return;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.open("GET", url + '_.pdf', true);
      xmlhttp.responseType = "blob";
      xmlhttp.onreadystatechange = function () {
          if (xmlhttp.readyState === XMLHttpRequest.DONE) {
              if (xmlhttp.status === 200) {
                  this.jsReadFiles(xmlhttp.response, imageobj);
              } else {
                  console.error("Failed to load image", url);
              }
          }
      }.bind(this);
      xmlhttp.send(null);
    },
    // 格式化数字
    formatCount(count) {
      if (count >= 10000) {
        return (count / 10000).toFixed(1) + 'w';
      }
      return count;
    },
    // 跳转详情
    goToDetail(item) {
      
        this.$router.push(`/detail?id=${item.id}`);
      
    }
  }
};
</script>

<style lang="scss" scoped>
/* 页面深色奢华背景 */
.book-container {
  min-height: 100vh;
//   background-color: #11121d;
  display: flex;
  flex-direction: column;
  color: #fff;
  padding-bottom: 90px; /* 为底部炫酷导航留出空间 */
}

/* ================= 炫酷底部导航 ================= */
.cyber-tabbar {
  position: fixed;
  bottom: 16px;
  left: 16px;
  right: 16px;
  height: 64px;
  background: rgba(20, 22, 34, 0.85);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-radius: 32px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 0 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5), inset 0 1px 1px rgba(255, 255, 255, 0.1);
  z-index: 100;
}

.tab-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff; /* 默认状态下也改为白色 */
  opacity: 0.9; /* 默认状态降低透明度以区分选中 */
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  width: 60px;
  position: relative;
  
  .tab-icon {
    font-size: 22px;
    margin-bottom: 4px;
    transition: transform 0.3s;
    color:#fff;
  }
  
  .tab-text {
    font-size: 10px;
    font-weight: 500;
    transition: all 0.3s;
    color:#fff;
  }
  
  &.active {
    opacity: 1; /* 选中状态完全不透明，高亮白色 */
    
    .tab-icon {
      transform: translateY(-4px) scale(1.1);
      color: #fff; /* 保持白色 */
      text-shadow: 0 0 10px rgba(255, 255, 255, 0.6); /* 换成白色外发光 */
    }
    
    .tab-text {
      transform: translateY(-2px);
      color: #fff; /* 保持白色 */
      font-weight: bold;
    }
    
    &::after {
      content: '';
      position: absolute;
      bottom: -4px;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background: #fff; /* 白点指示器 */
      box-shadow: 0 0 8px #fff;
    }
  }
  
  &:active {
    transform: scale(0.9);
  }
}

/* 覆盖导航栏样式 */
::v-deep .dark-nav {
  background-color: #ffffff !important;
  border-bottom: 1px solid #f2f3f5;
  .van-nav-bar__title {
    color: #323233 !important;
    font-weight: bold;
  }
  .van-icon {
    color: #323233 !important;
  }
  &::after {
    display: none;
  }
}

/* ================= 分类区域 ================= */
.category-container {
  background-color: #ffffff;
  padding: 10px 12px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.main-category {
  display: flex;
  gap: 20px;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f2f3f5;
  
  .main-cat-item {
    font-size: 16px;
    color: #646566;
    font-weight: 500;
    padding-bottom: 4px;
    position: relative;
    transition: all 0.3s;
    
    &.active {
      color: #323233;
      font-weight: bold;
      font-size: 17px;
      
      &::after {
        content: '';
        position: absolute;
        bottom: -11px;
        left: 50%;
        transform: translateX(-50%);
        width: 16px;
        height: 3px;
        background-color: #ee0a24; /* Vant主题红 */
        border-radius: 2px;
      }
    }
  }
}

.sub-category-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* 4列适合4个字的分类名 */
  gap: 10px;
}

.sub-cat-tag {
  background-color: #f7f8fa;
  color: #323233;
  font-size: 13px;
  text-align: center;
  padding: 8px 4px;
  border-radius: 6px;
  transition: all 0.2s;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  
  &.active {
    background-color: #fdebee; /* 浅红底色 */
    color: #ee0a24; /* 主题红 */
    font-weight: bold;
  }
  
  &:active {
    opacity: 0.7;
  }
}

/* ================= 列表区域 ================= */
.list-container {
  flex: 1;
  padding: 0 12px;
}

.book-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

/* ================= 单个卡片 ================= */
.book-card {
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border: 1px solid #f8f8f8;
  transition: transform 0.2s;
  
  &:active {
    transform: scale(0.98);
  }
}

.cover-wrapper {
  position: relative;
  width: 100%;
  height: 140px; /* 固定高度 140px */
  
  .cover-img {
    width: 100%;
    height: 100%;
    display: block;
  }
  
  /* 左上角类型角标 */
  .type-badge {
    position: absolute;
    top: 6px;
    left: 6px;
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: bold;
    color: #fff;
    background-color: rgba(247, 156, 38, 0.9); /* 橙色半透明 */
    z-index: 1;
    backdrop-filter: blur(4px);
  }
  
  /* 右上角状态角标 */
  .status-badge {
    position: absolute;
    top: 6px;
    right: 6px;
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: bold;
    color: #fff;
    background-color: rgba(7, 193, 96, 0.9); /* 绿色半透明，代表连载/完结状态 */
    z-index: 1;
    backdrop-filter: blur(4px);
  }
}

.book-info {
  padding: 6px;
  display: flex;
  flex-direction: column;
  flex: 1;
  
  .book-title {
    font-size: 12px;
    font-weight: bold;
    // color: #fff;
    line-height: 1.4;
    margin-bottom: 4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .book-time {
    font-size: 10px;
    color: #8a8e9f;
    margin-bottom: 6px;
  }
  
  .book-stats {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: auto;
    
    .stat-item {
      font-size: 10px;
      color: #8a8e9f;
      display: flex;
      align-items: center;
      gap: 4px;
      
      .star-icon {
        color: #f79c26; /* 收藏星标稍微高亮 */
      }
    }
  }
}

/* ================= 刷新组件深色定制 ================= */
::v-deep .dark-refresh {
  .van-pull-refresh__track {
    min-height: 50vh;
  }
  .van-pull-refresh__head,
  .van-list__loading,
  .van-list__finished-text {
    color: #8a8e9f;
  }
}
</style>
